// Ленивая загрузка изображений: пока <img> не попал в область видимости,
// у него заполнен только data-src (и, опционально, data-srcset), а не src.
// При появлении элемента во вьюпорте атрибуты переносятся в src/srcset,
// и браузер начинает загрузку. Поддерживается вёрстка с <picture> — сначала
// обновляются вложенные <source data-srcset>, и только потом сам <img>,
// иначе браузер выберет источник раньше, чем мы успеем его подменить.

const ROOT_MARGIN = "200px 0px";

function loadImage($img) {
    const $picture = $img.closest("picture");

    if ($picture) {
        $picture.querySelectorAll("source[data-srcset]").forEach(($source) => {
            $source.srcset = $source.dataset.srcset;
            delete $source.dataset.srcset;
        });
    }

    if ($img.dataset.srcset) {
        $img.srcset = $img.dataset.srcset;
        delete $img.dataset.srcset;
    }

    $img.addEventListener("load", () => $img.classList.add("is-loaded"), { once: true });

    $img.src = $img.dataset.src;
    delete $img.dataset.src;
}

export const lazyLoadImages = (root = document) => {
    const $images = root.querySelectorAll("img[data-src]");
    if (!$images.length) return;

    if (!("IntersectionObserver" in window)) {
        $images.forEach(loadImage);
        return;
    }

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            loadImage(entry.target);
            obs.unobserve(entry.target);
        });
    }, { rootMargin: ROOT_MARGIN });

    $images.forEach(($img) => observer.observe($img));
};
